import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiClock } = FiIcons;

const ContactInfo = ({ variant = "default", className = "" }) => {
  const contactData = {
    // phone: {
    //   icon: FiPhone,
    //   label: "Phone",
    //   value: "+44 7769 061291",
    //   href: "tel:+447769061291",
    //   display: "07769061291",
    //   subtitle: "Mon-Fri 8am-6pm"
    // },
    email: {
      icon: FiMail,
      label: "Email",
      value: "hello@wedesignedit.co.uk",
      href: "mailto:hello@wedesignedit.co.uk",
      display: "hello@wedesignedit.co.uk",
      subtitle: "We'll respond within 24 hours"
    },
    // address: {
    //   icon: FiMapPin,
    //   label: "Office",
    //   value: "59 Walton St, Aylesbury HP21 7QG",
    //   display: "59 Walton St, Aylesbury HP21 7QG",
    //   subtitle: "United Kingdom"
    // },
    hours: {
      icon: FiClock,
      label: "Working Hours",
      value: "Monday - Friday: 8:00 AM - 6:00 PM",
      display: "Monday - Friday: 8:00 AM - 6:00 PM",
      subtitle: "Weekend consultations available"
    }
  };

  if (variant === "simple") {
    return (
      <div className={`space-y-4 ${className}`}>
        {Object.entries(contactData).map(([key, info]) => (
          <div key={key} className="flex items-center space-x-3">
            <SafeIcon icon={info.icon} className="text-orange-500" />
            <div>
              {info.href ? (
                <a 
                  href={info.href} 
                  className="text-white hover:text-orange-400 transition-colors duration-300"
                >
                  {info.display}
                </a>
              ) : (
                <span className="text-white">{info.display}</span>
              )}
              {info.subtitle && (
                <div className="text-slate-400 text-sm">{info.subtitle}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`space-y-6 ${className}`}>
      {Object.entries(contactData).map(([key, info]) => (
        <div key={key} className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
            <SafeIcon icon={info.icon} className="text-white" />
          </div>
          <div>
            <h4 className="font-semibold mb-1 text-slate-300">{info.label}</h4>
            {info.href ? (
              <a 
                href={info.href} 
                className="text-slate-300 hover:text-white transition-colors duration-300"
              >
                {info.display}
              </a>
            ) : (
              <p className="text-slate-300">{info.display}</p>
            )}
            {info.subtitle && (
              <p className="text-slate-400 text-sm">{info.subtitle}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactInfo;